export const STEPS_BANNER_KEY = "StepsBanner";
export const PROMOTIONAL_BANNER_KEY = "PromotionalBanner";
